import React from 'react';
import { motion } from 'framer-motion';
import { User, Terminal } from 'lucide-react';

const Profile = ({ data }) => {
  return (
    <section id="profil" className="py-20 section-spacing">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        className="bg-dark-surface rounded-2xl p-8 border border-violet-500/20 shadow-2xl relative overflow-hidden"
      >
        {/* Effet de code en arrière-plan */}
        <div className="absolute top-0 right-0 text-8xl opacity-5 font-mono text-gray-600">
          {'{...}'}
        </div>
        
        <div className="relative z-10">
          <div className="flex items-center gap-3 mb-6">
            <div className="bg-violet-600/20 p-3 rounded-full">
              <User className="text-violet-400" size={28} />
            </div>
            <div>
              <h2 className="text-3xl md:text-4xl font-bold gradient-text mb-1">Qui je suis</h2>
              <div className="text-xs font-mono text-gray-500">$ cat about.md</div>
            </div>
          </div>
          
          <div className="font-mono text-gray-300 text-lg leading-relaxed pl-4 border-l-4 border-violet-500/50">
            <p>{data.profile}</p>
          </div>

          {/* Signature style terminal */}
          <div className="mt-6 flex items-center gap-2 text-sm font-mono text-gray-500">
            <Terminal size={14} className="text-violet-400" />
            <span>~/richard/ $ <span className="text-green-400">./whoami</span> --complete</span>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default Profile;